export default __webpack_public_path__ + "static/media/ctf-logo.ef89a729.png";